import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

export default class ApplicationRoute extends Route {
  buildRouteInfoMetadata() {
    return { isInvalidRoute: true };
  }

  @service ssr;

  beforeModel(transition) {
    this.ssr.setStatus(404);
  }
}
